// import React from 'react';
// import { Route ,Redirect } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';

// const ProtectedRoute = ({ component: Component, allowedRoles, userRole, ...rest }) => {
//   // Check if the user's role is allowed to access the route
//   const isAllowed = allowedRoles.includes(userRole);
//   const navigate=useNavigate();
//     console.log("IN protected route")
//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         isAllowed ? (
//           <Component {...props} />
//         ) : (
//         //   <Redirect to="/unauthorized" /> // Redirect to an unauthorized page or show an error message
//              navigate('/')
        
//         )
//       }
//     />
//   );
// };

// export default ProtectedRoute;
